"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.echainDomainVersion = void 0;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../../package.json');
const extractVersionFromPackageJson = (json) => {
    var _a;
    return (_a = json === null || json === void 0 ? void 0 : json.version) !== null && _a !== void 0 ? _a : 'NO_VERSION_FOUND';
};
const echainDomainVersion = (isDevMode = false) => {
    // this is needed for local development (watcher)
    // .. AND tests!
    // since the webpack magic is only executed during builds!
    if (isDevMode)
        return '0.0.0-domain-devmode-version';
    return extractVersionFromPackageJson(packageJson);
};
exports.echainDomainVersion = echainDomainVersion;
//# sourceMappingURL=version.js.map